import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image.inner';

const Illustration = ({ alt, cursor, name }) => (
  <Image cursor={cursor} width={192} height={98} name={name} alt={alt} />
);

Illustration.defaultProps = {
  cursor: 'default',
};

Illustration.propTypes = {
  alt: PropTypes.string.isRequired,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  name: PropTypes.string.isRequired,
};

export default Illustration;
